import { Component, EventEmitter, Input, Output } from '@angular/core';

import { Utils } from 'core/utils';

export interface SingleOptionChooserOption
{
  label: string;
  value: any;
}

export enum DisplayStyle {
  DropDown,
  RadioButton,
}

@Component({
  selector: 'single-option-chooser',
  templateUrl: './single-option-chooser.component.html',
  styleUrls: ['./single-option-chooser.component.scss'],
})
export class SingleOptionChooserComponent
{
  @Input() public displayStyle: DisplayStyle;
  @Input() public options: Array<any> = [];
  @Input() public selectedValue: any;
  @Output() public selectedValueChange: EventEmitter<any>
      = new EventEmitter<any>();

  public trackByLabel: Object = Utils.trackByLabel;
}



// WEBPACK FOOTER //
// ./src/app/controls/single-option-chooser/single-option-chooser.component.ts